export default {
  'name': 'required|min:1|max:255',
  'blade_image': 'required',
  'blade_image_description': 'required|min:1|max:255'
}
